/* validate user entered password match to requirement */
export const isPasswordValid = (password) => {
    if( /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/.test(password)){
        return true;
    }
}


